export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
            联系我们
          </h2>
          <p className="mt-2 text-sm text-foreground-500 font-label">
            有任何建议、资源投稿或合作需求，欢迎通过以下方式联系
          </p>

          <div className="mt-8 p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/60">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-2 text-sm">
              <span className="font-heading font-semibold text-foreground-800 whitespace-nowrap">联系邮箱：</span>
              <span className="text-primary-600 font-label font-medium">contact@nencao-video.com</span>
            </div>
            <p className="mt-3 text-xs text-foreground-400 font-label">
              我们会在24小时内回复您的邮件
            </p>

            <div className="mt-6 flex flex-wrap justify-center gap-4">
              <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-primary-50 text-primary-700 font-label text-sm">
                <i className="ri-mail-line"></i>
                <span>资源投稿</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-accent-50 text-accent-700 font-label text-sm">
                <i className="ri-briefcase-4-line"></i>
                <span>商务合作</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-secondary-50 text-secondary-700 font-label text-sm">
                <i className="ri-bug-line"></i>
                <span>问题反馈</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}